import apiService, { JiraApi, getUserName } from "./lensService";  // Importing API service and JiraApi instance
import { ShowGlobalErrorAlert, toggleGlobalAlert } from "../actions"


// Function to load Jira users
export const loadJiraUsers = async () => {
    const { data } = await JiraApi.get(`api/jira/v1/users?username=${getUserName()}`);
    return data?.data;  // Return the users data from the API response
}

// Function to load Jira projects
export const loadJiraProjects = async () => {
    const { data } = await JiraApi.get(`api/jira/v1/projects?username=${getUserName()}`);
    return data?.data;  // Return the projects data from the API response
}

// Function to load Jira issue statuses
export const loadJiraStatuses = async () => {
    const { data } = await JiraApi.get(`api/jira/v1/issueStatus?username=${getUserName()}`);
    return data?.data;  // Return the statuses data from the API response
}

// Function to create a new Jira ticket with multipart/form-data
export const createJiraTicket = async (formData, dispatch) => {
    try{
        const { data } = await JiraApi.post(`api/jira/v1/issue`, formData);
        await dispatch(toggleGlobalAlert('Jira Ticket successfully created'));
        return data?.data; // Return the created ticket data from the API response
         
    }catch(e){
        await dispatch(ShowGlobalErrorAlert(e))
    }
};


// Function to update test result
export const updateTestResult = async (id, jira, channel) => {
    // Use appropriate API service based on the channel
    // const { data } = channel === CHANNELS.DIGITAL
    //     ? await digitalApiService.put(`/results/${id}?jiraTicket=${jira}`)
    //     : await apiService.put(`/results/${id}?jiraTicket=${jira}`);
    
    // return data?.data;  // Return the updated result data from the API response
}

// Function to update a Jira ticket
export const updateJiraTicket = async (issueId, formData) => {
    const { data } = await JiraApi.put(`api/jira/v1/issue?username=${getUserName()}&issueId=${issueId}`, formData);
    return data?.data;  // Return the updated ticket data from the API response
}

// Function to get Jira status of a specific issue
export const getJiraStatus = async (issueId) => {
    const { data } = await JiraApi.get(`api/jira/v1/issue?username=${getUserName()}&issueId=${issueId}`);
    return data?.data;  // Return the status data of the specified Jira issue
}
